import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import apiClient from '../api/api-client'
import { AxiosResponse } from 'axios'

import { Fachbereich, FachbereichCollection } from '../model'
import { useLoading } from '@/js/utils/useLoading'

export const useFachbereichStore = defineStore('fachbereich', () => {
    const { isLoading, setLoading, errors, getError, hasError } = useLoading()
    const fachbereiche = ref<Array<Fachbereich>>([])

    const getFachbereiche = computed(() =>
        fachbereiche.value.sort((a, b) => Number(a.hsaId ?? 0) - Number(b.hsaId ?? 0))
    )

    const getFachbereichById = computed(() => {
        return (fachbereichId: string) => {
            return fachbereiche.value.find((fachbereich) => {
                return fachbereich.fachbereichId === fachbereichId
            })
        }
    })
    const getFachbereichByIri = computed(() => {
        return (fachbereichIri: string) => {
            return fachbereiche.value.find((fachbereich) => {
                return fachbereich['@id'] === fachbereichIri
            })
        }
    })

    const availableFachbereiche = computed(() => {
        return fachbereiche.value.map((fachbereich) => ({
            title: fachbereich.kurzName as string,
            value: fachbereich['@id'] as string
        }))
    })
    // const replaceFachbereichInState = (newFachbereich: Fachbereich) => {
    //     const index = fachbereiche.value.findIndex(
    //         (fachbereich) => fachbereich.fachbereichId === newFachbereich.fachbereichId
    //     )
    //     fachbereiche.value.splice(index, 1, newFachbereich)
    // }

    async function fetchFachbereiche(): Promise<void> {
        await setLoading('fetching fachbereiche', async () => {
            fachbereiche.value = []
            const url = '/api/fachbereiche'
            const response: AxiosResponse<FachbereichCollection, any> = await apiClient.get(url, {
                params: {
                    pagination: false
                }
            })
            fachbereiche.value = response.data['hydra:member']
        })
    }

    return {
        fachbereiche,
        isLoading,
        errors,
        hasError,
        getError,
        fetchFachbereiche,
        getFachbereiche,
        getFachbereichById,
        getFachbereichByIri,
        availableFachbereiche,
    }
})
